import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

class ProductDeliveryTime extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateDeliveryTime);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateDeliveryTime);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  updateDeliveryTime = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newDeliveryTime = event.detail.data.html.querySelector('product-delivery-time');

    if (!newDeliveryTime) {
      this.setAttribute('hidden', '');
      return;
    }

    morph(this, newDeliveryTime, { childrenOnly: true });

    if (newDeliveryTime.hasAttribute('hidden')) {
      this.setAttribute('hidden', '');
    } else {
      this.removeAttribute('hidden');
    }  };
}

if (!customElements.get('product-delivery-time')) {
  customElements.define('product-delivery-time', ProductDeliveryTime);
}
